<template>
  <layout name="Notification">
    <div class="fw">
      <div class="logout">
        <VButton label="Logout" @click="_logout"></VButton>
      </div>
      <VSystemMessage :primaryText="primaryText">
        <div class="billing-blocker__wrapper">
          <WithLoader :isLoading="isPlaidSaving">
            <div class="billing-blocker__content">
              <p class="description">
                Sign in to your bank to instantly verify <br />your bank account
              </p>
              <div class="btn">
                <PlaidLink
                  clientName="Inkit"
                  product="transactions"
                  :env="plaidMode"
                  :publicKey="plaidKey"
                  :webhook="_origin"
                  :onSuccess="onPlaidSuccess"
                >
                  <VButton label="Continue" size="giant"> </VButton>
                </PlaidLink>
              </div>
            </div>
          </WithLoader>
        </div>
      </VSystemMessage>
    </div>
  </layout>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import Layout from "@/layouts/Layout";

// mixins
import withNavigate from "@/mixins/withNavigate";
import withToasted from "@/mixins/withToasted";

// components
import VSystemMessage from "@/components/VSystemMessage";
import PlaidLink from "@/components/PlaidLink";
import WithLoader from "@/components/WithLoader";
import VButton from "@/components/VButton";

import { plaidKey, plaidMode } from "@/config";

export default Vue.component("BillingBlockingPage", {
  metaInfo: {
    title: "Payment"
  },

  components: {
    PlaidLink,
    VSystemMessage,
    WithLoader,
    VButton,
    Layout
  },

  mixins: [withNavigate, withToasted],

  data() {
    return {
      primaryText: "Add Bank",
      plaidKey,
      plaidMode,
      isPlaidSaving: false
    };
  },

  methods: {
    _redirectIfValidPlan() {
      if (this.identity && this.identity.account.active_payment) {
        this.navigate("/dashboard");
      }
    },

    onPlaidSuccess(token, accountInfo) {
      this.isPlaidSaving = true;
      this.savePlaidAccount({
        token,
        account_id: accountInfo.account.id,
        onSuccess: () => {
          this.toast("Bank account has been saved. Logging in...");

          this.fetchIdentity({
            onSuccess: identity => {
              this.isPlaidSaving = false;
              this.navigate("/dashboard");
            }
          });
        },

        onError: e => {
          this.isPlaidSaving = false;
          const err = e.description
            ? e.description
            : "Something went wrong. Please, try again later";
          this.toast(err, "error");
        }
      });
    },

    _logout() {
      this.logout(() => {
        this.navigate("/login");
      });
    },

    ...mapActions("billing", ["savePlaidAccount"]),
    ...mapActions("account", ["fetchIdentity"]),
    ...mapActions("auth", ["logout"])
  },

  computed: {
    _origin() {
      if (!window.location.origin) {
        window.location.origin =
          window.location.protocol +
          "//" +
          window.location.hostname +
          (window.location.port ? ":" + window.location.port : "");
      }
      return window.location.origin;
    },
    ...mapGetters("account", ["identity", "identityLoaded"]),
    ...mapGetters("billing", ["bankAccounts"])
  },

  created() {
    // if user has an active subscription
    this._redirectIfValidPlan();
  },

  watch: {
    identity: function(itm) {
      this._redirectIfValidPlan();
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "billing-blocker";
.#{$ns}__wrapper {
  .#{$ns}__content {
    .description {
      text-align: center;
      line-height: 1.62;
      color: $secondary-text-color;
    }
  }
}

.btn {
  margin-top: 58px;
}

.logout {
  position: absolute;
  top: 5%;
  right: 5%;
}
</style>

<style lang="scss">
.billing-blocker-loader {
  align-items: center;
}
</style>
